import React from "react";
function Bank () {
    return (

        <h2>Bank</h2>
    )
    
}
export default Bank;